import PropTypes from 'prop-types';
import React from 'react';

import useGroup from '../../hooks/use_group';
import useTranslation from '../../hooks/use_translation';
import { getVariantByLanguage } from '../../utils/helpers';
import Link from './link';

const Breadcrumb = ({
	allergen = false,
	article = false,
	body = false,
	business = false,
	calculator = false,
	className,
	fact = false,
	home = true,
	links,
	location = false,
	marker = false,
	partner = false,
	product_brand = false,
	service = false,
	support = false,
	symptom = false,
	test = false,
}) => {
	const { items: groups_data } = useGroup();
	const { language, t } = useTranslation('component_breadcrumb');

	if (groups_data) {
		for (const key in links) {
			if (links[key].id && links[key].type == 'group') {
				const tmp = groups_data.find(
					(value) => value.group_id == links[key].id,
				);

				const group_title = getVariantByLanguage(language, tmp.group_variants);
				if (group_title) {
					links[key].title = group_title.title;
				}

				const group_slug = getVariantByLanguage('sv', tmp.group_variants);
				if (group_slug) {
					links[key].url = `${links[key].base_url}/${group_slug.slug}`;
				}
			}
		}
	}

	return (
		<ol className={`breadcrumb xs ${className}`}>
			{home && (
				<li className="breadcrumb-item">
					<Link to="/">{t('t1')}</Link>
				</li>
			)}

			{fact && (
				<li className="breadcrumb-item">
					<Link to="/fakta">{t('t2')}</Link>
				</li>
			)}

			{allergen && (
				<li className="breadcrumb-item">
					<Link to="/allergener/">{t('t3')}</Link>
				</li>
			)}

			{article && (
				<li className="breadcrumb-item">
					<Link to="/artiklar/">{t('t4')}</Link>
				</li>
			)}

			{body && (
				<li className="breadcrumb-item">
					<Link to="/kroppen/">{t('t15')}</Link>
				</li>
			)}

			{business && (
				<li className="breadcrumb-item">
					<Link to="/foretagshalsovard">{t('t11')}</Link>
				</li>
			)}

			{location && (
				<li className="breadcrumb-item">
					<Link to="/mottagningar/">{t('t10')}</Link>
				</li>
			)}
			{calculator && (
				<li className="breadcrumb-item">
					<Link to="/kalkylatorer/">{t('t12')}</Link>
				</li>
			)}

			{marker && (
				<li className="breadcrumb-item">
					<Link to="/markorer/">{t('t5')}</Link>
				</li>
			)}

			{partner && (
				<li className="breadcrumb-item">
					<Link to="/partners/">{t('t6')}</Link>
				</li>
			)}

			{product_brand && (
				<li className="breadcrumb-item">
					<Link to="/varumarken/">{t('t14')}</Link>
				</li>
			)}

			{service && (
				<li className="breadcrumb-item">
					<Link to="/vardtjanster/">{t('t13')}</Link>
				</li>
			)}

			{support && (
				<li className="breadcrumb-item">
					<Link to="/support/">{t('t7')}</Link>
				</li>
			)}

			{symptom && (
				<li className="breadcrumb-item">
					<Link to="/symtom/">{t('t8')}</Link>
				</li>
			)}

			{test && (
				<li className="breadcrumb-item">
					<Link to="/tester/">{t('t9')}</Link>
				</li>
			)}

			{links &&
				links.map((value, index) => {
					if (!value.title) return;
					return (
						<li
							className={`breadcrumb-item ${value.active ? 'active' : ''}`}
							key={index}
						>
							{value.url && <Link to={value.url}>{value.title}</Link>}
							{!value.url && <>{value.title}</>}
						</li>
					);
				})}
		</ol>
	);
};

Breadcrumb.propTypes = {
	allergen: PropTypes.bool,
	article: PropTypes.bool,
	business: PropTypes.bool,
	calculator: PropTypes.bool,
	className: PropTypes.string,
	fact: PropTypes.bool,
	home: PropTypes.bool,
	links: PropTypes.array,
	location: PropTypes.bool,
	marker: PropTypes.bool,
	partner: PropTypes.bool,
	product_brand: PropTypes.bool,
	service: PropTypes.bool,
	support: PropTypes.bool,
	symptom: PropTypes.bool,
	test: PropTypes.bool,
};

export default Breadcrumb;
